import React, { useEffect, useState } from "react";
import { apiFetch } from "../../components/helpers";

const TodayAppointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTodayAppointments();
  }, []);

  const fetchTodayAppointments = async () => {
    setLoading(true);
    try {
      const doctor_id = localStorage.getItem("doctor_id") || 1;
      const res = await apiFetch(`${process.env.REACT_APP_GET_DOCTORE_APPOINTMENTS}?doctor_id=${doctor_id}`);
      setAppointments(res.data || []);
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-3 p-lg-4">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4">
        <div>
          <h2 className="fw-bold mb-1" style={{ color: "#0A1628" }}>
            Today's Appointments
          </h2>
          <p className="text-muted mb-0">Overview of your scheduled visits for today.</p>
        </div>
        <button
          className="btn btn-primary shadow-sm"
          onClick={fetchTodayAppointments}
          style={{ background: "#378ADD", border: "none" }}
        >
          ↻ Refresh
        </button>
      </div>

      <div className="card border-0 shadow-sm rounded-4 w-100">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead style={{ background: "#f8f9fa", color: "#6c757d" }}>
              <tr>
                <th className="px-4 py-3 border-0 rounded-start-3">Patient Name</th>
                <th className="px-4 py-3 border-0">Mobile</th>
                <th className="px-4 py-3 border-0">Time</th>
                <th className="px-4 py-3 border-0">Status</th>
                <th className="px-4 py-3 border-0 rounded-end-3">Notes</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : appointments.length > 0 ? (
                appointments.map((item) => (
                  <tr key={item.appointment_id}>
                    <td className="px-4 py-3 fw-bold" style={{ color: "#0A1628" }}>
                      {item.name}
                    </td>
                    <td className="px-4 py-3 text-muted">{item.mobile}</td>
                    <td className="px-4 py-3">
                      <span className="badge bg-soft-primary text-primary px-3 py-2 rounded-pill">
                        {item.appointment_time}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`badge px-3 py-2 rounded-pill ${
                          item.status?.toLowerCase() === "completed"
                            ? "bg-success"
                            : item.status?.toLowerCase() === "cancelled"
                            ? "bg-danger"
                            : "bg-warning text-dark"
                        }`}
                      >
                        {item.status || "Scheduled"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-muted">{item.notes || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-5 text-muted">
                    <div className="mb-3 fs-1 opacity-50">📅</div>
                    No appointments scheduled for today.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TodayAppointments;